export default {
  title: {
    en: 'You have skipped your next shipment.',
  },
  text: {
    en: `
      Needed a break? We understand!
      <br /><br />
      Your card is already in the billing cycle for this month and is in the process of being charged,
      but don’t worry, there are two things we can do to help you right now.
      <br /><br />
      You have the option to either cancel the shipment and have the payment refunded,
      or receive your last Scentbird shipment. If you choose to get your card refunded,
      the payment should be back in your account in 7 to 10 business days.
    `,
  },
  buttons: {
    refund: {
      en: 'Get a refund',
    },
    receive: {
      en: `Receive this month's shipment`,
    },
  },
}
